import { CloseCircleOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Input } from 'antd';

import type { ChangeEventHandler, FC } from 'react';

interface SubscriptionsFiltersProps {
  searchTerm: string;
  onChangeSearchTerm: ChangeEventHandler<HTMLInputElement>;
  onSearch: () => void;
  onReset: () => void;
}

export const SubscriptionsFilters: FC<SubscriptionsFiltersProps> = ({
  searchTerm,
  onChangeSearchTerm,
  onSearch,
  onReset,
}) => (
  <div className="Subscriptions__filters">
    <Input
      addonBefore={<SearchOutlined />}
      placeholder="Введите название абонемента"
      value={searchTerm}
      onChange={onChangeSearchTerm}
      onPressEnter={onSearch}
      className="Subscriptions__search"
      data-testid="subscriptions-search"
    />
    <div className="Subscriptions__filter-buttons">
      <Button
        icon={<CloseCircleOutlined />}
        onClick={onReset}
        className="Subscriptions__filter-button"
        data-testid="subscriptions-reset"
      >
        Сброс
      </Button>
      <Button
        type="primary"
        onClick={onSearch}
        className="Subscriptions__filter-button"
        data-testid="subscriptions-search-button"
      >
        Показать
      </Button>
    </div>
  </div>
);
